// components/PaymentSummary.tsx
import React from "react";
import { Order } from "src/shared/services/interfacev2";
import { roundValue } from "../../home/utils/formatters";
import LabelValueRow from "./LabelValueRow";

interface PaymentSummaryProps {
  orderData: Order;
}

const PaymentSummary: React.FC<PaymentSummaryProps> = ({ orderData }) => {
  const transaction = orderData.orders?.[0];

  const total = transaction?.finalAmount ?? transaction?.orderAmount ?? 0;
  const received = transaction?.receivedAmount ?? 0;
  const balance = transaction?.remainingAmount ?? 0;

  return (
    <div className="border-y border-dashed border-black py-3 mb-3 text-sm">
      <LabelValueRow label="Total:" value={roundValue(total)} bold />
      <LabelValueRow label="Received:" value={roundValue(received)} />
      <LabelValueRow label="Balance:" value={roundValue(balance)} bold />
    </div>
  );
};

export default PaymentSummary;
